<mat-toolbar>
  Puntos de conexión
  <span class="spacer"></span>
  <button mat-icon-button matTooltip="Volver a Ajustes" routerLink="/settings"><mat-icon color="primary">arrow_back</mat-icon></button>
  <button mat-icon-button matTooltip="Comprobar conexiones" (click)="refreshConnections()" [disabled]="checkingConnections"><mat-icon color="primary">wifi</mat-icon></button>
  <button mat-icon-button matTooltip="Recargar datos" (click)="getScales()"><mat-icon color="primary">refresh</mat-icon></button>
  @if (authService.canAccessSocketDiagnostico()) {
    <button mat-button [matMenuTriggerFor]="beforeMenu"><mat-icon color="primary">menu</mat-icon></button>
    <mat-menu #beforeMenu="matMenu" xPosition="before">
      <button mat-menu-item (click)="newScale()"><mat-icon color="primary">add_circle_outline</mat-icon> Añadir punto de conexión</button>
    </mat-menu>
  }
</mat-toolbar>

@if (showProgressBar) {
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
}

<div class="pageContent">
  <div class='tableHeader'>
    <mat-form-field class='buscarInput searchMobile'>
      <mat-label>Buscar</mat-label>
      <input matInput type="text" [(ngModel)]="filter" (keyup)="applyFilter($event)">
    </mat-form-field>
    <mat-form-field class="searchMobile">
      <mat-label>Estado</mat-label>
      <mat-select [(value)]="estado" (selectionChange)="getScales()">
        <mat-option value="all">Todos</mat-option>
        <mat-option value="true">Activo</mat-option>
        <mat-option value="false">Inactivo</mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div class='tableBlock'>
    <table mat-table [dataSource]="dataSource" matSort>
      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef> </th>
        <td mat-cell *matCellDef="let element" class='miniCell'>
          <button mat-icon-button [matMenuTriggerFor]="menu">
            <mat-icon matTooltip="Acciones">more_vert</mat-icon>
          </button>
          <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="editarScale(element.id)">
              <mat-icon color="primary">create</mat-icon>
              <span>Modificar</span>
            </button>
            <button mat-menu-item (click)="deleteScale(element.id)">
              <mat-icon color="primary">delete</mat-icon>
              <span>Eliminar</span>
            </button>
          </mat-menu>
        </td>
      </ng-container>

      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class='minWidth'> Nombre </th>
        <td mat-cell *matCellDef="let element" class='minWidth'> {{element.name}} </td>
      </ng-container>

      <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class='minWidth'> Descripción </th>
        <td mat-cell *matCellDef="let element" class='minWidth'> {{element.description}} </td>
      </ng-container>

      <ng-container matColumnDef="default_camion">
        <th mat-header-cell *matHeaderCellDef class='minWidth'> Camión def. </th>
        <td mat-cell *matCellDef="let element" class='minWidth'>
          {{ element.default_camion_label || '—' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="default_material">
        <th mat-header-cell *matHeaderCellDef class='minWidth'> Residuo def. </th>
        <td mat-cell *matCellDef="let element" class='minWidth'>
          {{ element.default_material_label || '—' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="connection">
        <th mat-header-cell *matHeaderCellDef class='minWidth'> Conexión </th>
        <td mat-cell *matCellDef="let element" class='minWidth'>
          @if (connectionState(element.id) === 'online') {
            <mat-icon class='green' [matTooltip]="connectionLabel(element.id)">wifi</mat-icon>
          } @else if (connectionState(element.id) === 'offline') {
            <mat-icon class='red' [matTooltip]="connectionLabel(element.id)">wifi_off</mat-icon>
          } @else {
            <mat-icon class='pending' [matTooltip]="connectionLabel(element.id)">hourglass_empty</mat-icon>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="active">
        <th mat-header-cell *matHeaderCellDef class='minWidth'> Activo </th>
        <td mat-cell *matCellDef="let element" class='minWidth'>
          @if (element.active === 'true') {
            <mat-icon class='green' matTooltip="Punto de conexión activo">fiber_manual_record</mat-icon>
          }
          @if (element.active === 'false') {
            <mat-icon class='red' matTooltip="Punto de conexión inactivo">fiber_manual_record</mat-icon>
          }
        </td>
      </ng-container>

      <tr class="mat-row" *matNoDataRow>
        <td class="emptyCell" colspan="8">
          No existen puntos de conexión...
          @if (authService.canAccessSocketDiagnostico()) {
            <br> <button mat-stroked-button (click)="newScale()">Crear punto de conexión</button>
          }
        </td>
      </tr>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>
  <mat-paginator [pageSize]="25" [pageSizeOptions]="pages" showFirstLastButtons></mat-paginator>
</div>

